import { AnswerItem, AnswerText, Title } from '../../styles.css';
import { Answer } from '../Answer';
import { SliderAnswer } from '../SliderAnswer';
import { AnswerCounter, AnswerList, QuestionCard } from './styles.css';
import textData from '../../../../data/data.json';
import { selectedLanguageAtom } from '../../../../recoil/atoms/languageAtom';
import { useRecoilValue } from 'recoil';

export const Question = ({ question }) => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { question: questionText } = textData[selectedLanguage];
    const questionType = question.type;
    let answers;

    switch (questionType) {
        case 'number':
            answers = <SliderAnswer question={question} />;
            break;

        case 'options':
            const answerOptionsItems = question.answers?.map((answer) => <Answer key={answer.id} answer={answer} />);
            answers = <AnswerList>{answerOptionsItems}</AnswerList>;
            break;

        default:
            if (!Object.entries(question.answers)?.length) {
                answers = <AnswerText sx={{ textAlign: 'center' }}>{questionText.text}</AnswerText>;
                break;
            }

            const answerTextItems = Object.entries(question.answers).map(([answer, count], index) => (
                <AnswerItem key={index}>
                    <AnswerText>{answer}</AnswerText>
                    {count > 1 && (
                        <AnswerCounter>⨯{count}</AnswerCounter>
                    )}
                </AnswerItem>
            ));
            answers = <AnswerList>{answerTextItems}</AnswerList>;
    }

    return (
        <QuestionCard>
            <Title dangerouslySetInnerHTML={{ __html: question.title }}></Title>
            {answers}
        </QuestionCard>
    );
};
